import type { ComponentConfig } from '@puckeditor/core'
import type { ReactNode } from 'react'
import ColorField from './ColorField'
import { RichText, richTextField } from './RichText'
import PaddingField, { type PaddingValue, defaultPadding, paddingToStyle } from './PaddingField'

export interface ParagraphProps {
    text: string | ReactNode
    color: string
    fontSize: number
    lineHeight: number
    alignment: 'left' | 'center' | 'right'
    padding: PaddingValue
}

export const ParagraphBlock: ComponentConfig<ParagraphProps> = {
    label: 'Paragraph',
    defaultProps: {
        text: 'Enter your text here.',
        color: '#374151',
        fontSize: 16,
        lineHeight: 1.6,
        alignment: 'left',
        padding: defaultPadding,
    },
    fields: {
        text: richTextField('Text', true),
        color: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Color" value={value} onChange={onChange} />,
        },
        fontSize: { type: 'number', label: 'Font Size', min: 10, max: 48 },
        lineHeight: { type: 'number', label: 'Line Height', min: 1, max: 3, step: 0.1 },
        alignment: {
            type: 'radio',
            label: 'Alignment',
            options: [
                { label: 'Left', value: 'left' },
                { label: 'Center', value: 'center' },
                { label: 'Right', value: 'right' },
            ],
        },
        padding: {
            type: 'custom',
            render: ({ value, onChange }) => <PaddingField value={value} onChange={onChange} />,
        },
    },
    render: ({ text, color, fontSize, lineHeight, alignment, padding }) => (
        <RichText as="div" value={text} style={{
            color,
            fontSize,
            lineHeight,
            textAlign: alignment,
            margin: 0,
            padding: paddingToStyle(padding),
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
        }} />
    ),
}
